import citiesDetails from 'app/config/files/citiesDetails.json';
import {
    CLEAR_AUTOCOMPLETE_RESULTS,
    SET_DEPARTURE_LOCATION,
    SET_ARRIVAL_LOCATION,
    SWITCH_LOCATIONS,
    STORE_AUTOCOMPLETE_RESULTS,
    STORE_CITY_DETAIL,
    REPORT_AUTOCOMPLETE_ERROR,
    TOGGLE_AUTOCOMPLETE_LOADING,
    CLEAR_AUTOCOMPLETE_ERROR,
} from 'app/store/actions';

const defaultState = {
    citiesDetails,
    hasCities: false,
    cities: {},
    cityPairs: {},
    cityTrainPairs: {},
    autocomplete: {
        departure: {
            default: [],
            current: [],
            loading: false,
            error: {
                present: false,
                id: null,
                level: null,
            },
        },
        arrival: {
            default: [],
            current: [],
            loading: false,
            error: {
                present: false,
                id: null,
                level: null,
            },
        },
    },
    departure: {
        id: null,
    },
    arrival: {
        id: null,
    },
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_DEPARTURE_LOCATION: {
            const newState = {
                ...state,
                departure: {
                    ...state.departure,
                    id: action.id,
                },
                autocomplete: {
                    ...state.autocomplete,
                    departure: defaultState.autocomplete.departure,
                },
            };

            // if the user selected the same as the arrival city, swap departure/arrival
            if (action.id === state.arrival.id) {
                newState.arrival = {
                    ...newState.arrival,
                    id: state.departure.id,
                };
                newState.autocomplete = {
                    ...state.autocomplete,
                    departure: state.autocomplete.arrival,
                    arrival: state.autocomplete.departure,
                };
            }

            return newState;
        }

        case TOGGLE_AUTOCOMPLETE_LOADING:

            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    [action.direction]: {
                        ...state.autocomplete[action.direction],
                        loading: action.loading,
                    },
                },
            };

        case SET_ARRIVAL_LOCATION:
            return {
                ...state,
                arrival: {
                    ...state.arrival,
                    id: action.id,
                },
                autocomplete: {
                    ...state.autocomplete,
                    arrival: defaultState.autocomplete.arrival,
                },
            };

        case SWITCH_LOCATIONS: {
            return {
                ...state,
                departure: {
                    ...state.departure,
                    id: state.arrival.id,
                },
                arrival: {
                    ...state.arrival,
                    id: state.departure.id,
                },
                autocomplete: {
                    ...state.autocomplete,
                    departure: state.autocomplete.arrival,
                    arrival: state.autocomplete.departure,
                },
            };
        }

        case STORE_CITY_DETAIL:
            return {
                ...state,
                citiesDetails: {
                    ...state.citiesDetails,
                    [action.locale]: {
                        ...state.citiesDetails[action.locale],
                        [action.city.id]: action.city,
                    },
                },
            };

        case REPORT_AUTOCOMPLETE_ERROR:
            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    [action.direction]: {
                        ...state.autocomplete[action.direction],
                        error: {
                            ...state.autocomplete[action.direction].error,
                            present: true,
                            id: action.id,
                            level: action.level,
                        },
                    },
                },
            };

        case CLEAR_AUTOCOMPLETE_ERROR:
            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    [action.direction]: {
                        ...state.autocomplete[action.direction],
                        error: {
                            ...state.autocomplete[action.direction].error,
                            present: false,
                            id: null,
                            level: null,
                        },
                    },
                },
            };

        case STORE_AUTOCOMPLETE_RESULTS:
            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    [action.direction]: {
                        ...state.autocomplete[action.direction],
                        [action.key]: action.results,
                        error: {
                            ...state.autocomplete[action.direction].error,
                            present: false,
                            id: null,
                            level: null,
                        },
                    },
                },
            };

        case CLEAR_AUTOCOMPLETE_RESULTS:
            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    [action.direction]: {
                        ...state.autocomplete[action.direction],
                        current: [],
                    },
                },
            };

        default:
            return state;
    }
};
